<template>
  <SettingsSection>
    <SettingsSectionTitle> General </SettingsSectionTitle>

    <SettingsSubsection
      v-if="hasSalesModule"
      title="Features"
    >
      <SettingsToggle
        label="Enable Products"
        :model-value="isProductsEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isProductsEnabled', value)
        "
      />
      <SettingsToggle
        label="Enable Cashiers"
        :model-value="isCashiersEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isCashiersEnabled', value)
        "
      />
      <SettingsToggle
        v-if="isCashiersEnabled"
        label="Allow login with no cashier"
        :model-value="allowLoginWithoutCashier"
        @update:model-value="
          (value) =>
            onUpdateSetting(
              'allowLoginWithoutCashier',
              value
            )
        "
      />
    </SettingsSubsection>

    <SettingsSubsection
      v-if="hasSalesModule"
      title="Payments"
    >
      <SettingsToggle
        label="Enable Cash"
        :model-value="isCashEnabled"
        @update:model-value="
          (value) => onUpdateSetting('isCashEnabled', value)
        "
      />
      <SettingsToggle
        v-if="
          acquirer !== 'evo' ||
          (acquirer === 'evo' &&
            evoConfig.gratuityIsAvailable)
        "
        label="Enable Gratuity"
        :model-value="isGratuityEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isGratuityEnabled', value)
        "
      />
      <SettingsToggle
        v-if="tenant.isProductsEnabled"
        label="Enable Split Payments"
        :model-value="isSplitPaymentsEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isSplitPaymentsEnabled', value)
        "
      />
    </SettingsSubsection>

    <SettingsSubsection
      v-if="tenant.isProductsEnabled && hasSalesModule"
      title="Service Charge"
    >
      <SettingsToggle
        label="Enable Service Charge"
        :model-value="isServiceChargeEnabled"
        @update:model-value="
          (value) =>
            onUpdateSetting('isServiceChargeEnabled', value)
        "
      />
      <template v-if="isServiceChargeEnabled">
        <SettingsDefaultServiceChargeForm
          :initial-values="{
            defaultServiceChargePercentage:
              tenant.defaultServiceChargePercentage,
            defaultServiceChargeFlat:
              tenant.defaultServiceChargeFlat,
          }"
        />
      </template>
    </SettingsSubsection>
    <SettingsSubsection title="Portal">
      <BaseSelect
        label="Default Export Format"
        :options="fileExportFormatOptions"
        :model-value="defaultExportFiletype"
        @update:model-value="
          (value) =>
            onUpdateSetting('defaultExportFiletype', value)
        "
      />
    </SettingsSubsection>
  </SettingsSection>
</template>

<script setup lang="ts">
import type { PartialUpdateTenant } from "@/services/settings/partialUpdateSettings"
const {
  defaultExportFiletype,
  isProductsEnabled,
  isCashiersEnabled,
  allowLoginWithoutCashier,
  isCashEnabled,
  isGratuityEnabled,
  hasSalesModule,
  isSplitPaymentsEnabled,
  isServiceChargeEnabled,
  tenant,
  acquirer,
  evoConfig,
  setTenantState,
} = useTenant()
const { options: fileExportFormatOptions } =
  useFileExportFormatOptions()

const onUpdateSetting = async <
  T extends keyof PartialUpdateTenant,
>(
  setting: T,
  value: PartialUpdateTenant[T]
) => {
  try {
    const newState = await partialUpdateSettings({
      [setting]: value,
    })
    setTenantState(newState)
  } catch {
    toast.error("Failed to update setting")
  }
}
</script>
